<template>
  <div class="space-between-y">
    <el-dialog title="商品详情" :visible.sync="info.dialog">
      <product-detail :product-detail="info.detail" v-if="info.dialog"></product-detail>
    </el-dialog>

    <div class="both-sides">
      <div class="space-between-x container-left">
        <input-item label="可见客户端">
          <el-radio-group @change="getData" v-model="filter.viewFor">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button label="CUSTOMER">C园长端</el-radio-button>
            <el-radio-button label="MIU">M家长端</el-radio-button>
          </el-radio-group>
        </input-item>
        <input-item label="关键字搜索">
          <el-input v-model="filter.keyword" placeholder="搜索商品名称/简介/详情" clearable></el-input>
        </input-item>
        <input-item label="按商品分类搜索">
          <el-select clearable filterable @change="getData" v-model="filter.typeId" placeholder="请选择分类">
            <el-option
                v-for="item in options.types"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </input-item>
        <input-item>
          <el-button type="primary" @click="getData">搜索</el-button>
        </input-item>
      </div>
      <div>
        <el-button type="primary" size="small" @click="addProduct">新增商品</el-button>
      </div>
    </div>

    <el-table :data="products" stripe border>
      <el-table-column label="商品编号" prop="id" width="80" show-overflow-tooltip></el-table-column>
      <el-table-column label="类别" prop="category" width="80" show-overflow-tooltip></el-table-column>
      <el-table-column label="商品" prop="name">
        <template v-slot:default="scope">
          <div class="product">
            <cloud-img :url="scope.row.cover" :img-height="50" :img-width="50" border-radius="5"></cloud-img>
            <div>
              <line-overflow :content="scope.row.name" :max-lines="1"/>
              <line-overflow :content="scope.row.brief" class="info-text" :max-lines="1"/>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="100" label="价格" align="right" prop="price" show-overflow-tooltip>
        <template v-slot:default="scope">
          <div class="price">{{ scope.row.price }}元</div>
        </template>
      </el-table-column>
      <el-table-column width="300" label="可见性" show-overflow-tooltip>
        <template v-slot:default="scope">
          <div class="radios">
            <el-radio size="mini" v-model="scope.row.viewFor" :label="null" border
                      @change="handleVisibilityChange(scope.row, null)">无
            </el-radio>
            <el-radio size="mini" v-model="scope.row.viewFor" label="CUSTOMER" border
                      @change="handleVisibilityChange(scope.row, 'CUSTOMER')">C园长端
            </el-radio>
            <el-radio size="mini" v-model="scope.row.viewFor" label="MIU" border
                      @change="handleVisibilityChange(scope.row, 'MIU')">M家长端
            </el-radio>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160" label="提交时间/提交人">
        <template v-slot:default="scope">
          <line-overflow :content="scope.row.createTime" :max-lines="1"></line-overflow>
          <line-overflow :content="scope.row.createBy" class="info-text" :max-lines="1"></line-overflow>
        </template>
      </el-table-column>

      <el-table-column fixed="right" align="center" label="操作" width="100">
        <template v-slot:default="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="text" @click="showDetail(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getData()"></pagination>
  </div>
</template>

<script>
import {product} from "@/api/product";
import ProductDetail from "@/components/product/ProductDetail.vue";
import {utils} from "@/util/utils";
import Pagination from "@/components/base/layout/Pagination.vue";
import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import ProductEdit from "@/components/product/ProductEdit.vue";
import {wmsRouter} from "@/router/wmsRouter";
import InputItem from "@/components/base/layout/InputItem.vue";

export default {
  name: 'ProductAll',
  components: {InputItem, ProductEdit, CloudImg, LineOverflow, Pagination, ProductDetail},

  data() {
    return {
      products: [],
      info: {
        dialog: false,
        detail: {},
      },

      options: {
        types: [],
      },

      filter: {
        viewFor: null,
        typeId: "",
        keyword: null,
      },


      page: {
        size: 10,
        current: 1,
        total: 0,
      },


      productBackup: [], // 列表备份（用于当操作失败时，撤销到未设置前的状态）
    };
  },

  created() {
    product.listTypes().then(res => {
      this.options.types = res.data;
    })

    this.getData();
  },

  methods: {
    addProduct() {
      wmsRouter.product.edit();
    },

    handleEdit(product) {
      wmsRouter.product.edit(product);
    },

    getData() {
      let loading = this.$loading({text: "加载中..."});

      product.listAll(this.filter.viewFor, this.filter.typeId, this.filter.keyword, this.page.current, this.page.size).then(res => {
        let page = res.data;
        this.products = page.list;
        this.page.total = page.total;
        this.productBackup = utils.obj.deepClone(this.products);
      }).finally(() => {
        loading.close();
      });
    },

    showDetail(id) {
      this.info.detail = this.products.find(item => item.id === id) || {};
      this.info.dialog = true;
    },

    async handleVisibilityChange(row, newViewFor) {
      const originalViewFor = row.viewFor; // 保存原始值

      try {
        // 更新后端数据
        await this.updateProductView(row.id, newViewFor);
      } catch (error) {
        // 如果请求失败，则恢复原来的状态
        row.viewFor = originalViewFor;
        this.$message.error("更新可见性失败，已恢复原状态");
      }
    },

    updateProductView(productId, newViewFor) {
      // 向后端请求更改可见性
      return product.updateProductView(productId, newViewFor);
    },
  },
};
</script>


<!--suppress CssUnusedSymbol -->
<style scoped>
.radios {
  display: flex;
  flex-direction: row;
  gap: 0;
  align-items: center;
  justify-content: center;
}

.el-radio {
  margin-right: 0;
}

.price {
  font-weight: bold;
  font-size: 15px;
}

.product {
  display: flex;
  gap: 5px;
}
</style>
